export default "__VITE_ASSET__CA7p0I6r__"